import { SelectListItem } from './SelectListItem';
import { SentimentPhraseDTO } from './SentimentPhraseDTO';

export class CommunicationTemplate {
  Confidential: { Value: string } = null;
  AssignedTo: { Value: string } = null;
  Priority: { Value: string } = null;
  Status: { Value: string } = null;
  InteractionType: SelectListItem = null;
  SentimentPhrases: SentimentPhraseDTO[] = null;
  AdditionalSharedProjectIDs?: string[] = null;
}
